import { z } from "zod/v4";

export const propertyKeySchema = z.union([z.string(), z.number(), z.symbol()]);
